import * as actionTypes from './workflow-type.constant';
import { IAction, IWorkflowType } from '@shared-components/models';

export const addWorkflowTypeRequest = (
  payload: IWorkflowType,
  triggerRefresh: any
): IAction<IWorkflowType> => {
  return {
    type: actionTypes.ADD_WORKFLOW_TYPE_REQUEST,
    payload,
    triggerRefresh,
  };
};

export const addWorkflowTypeSuccess = (
  payload: IWorkflowType
): IAction<IWorkflowType> => ({
  type: actionTypes.ADD_WORKFLOW_TYPE_SUCCESS,
  payload,
});

export const addWorkflowTypeFailure = (error: any): IAction<IWorkflowType> => ({
  type: actionTypes.ADD_WORKFLOW_TYPE_FAILURE,
  payload: error,
});

export const updateWorkflowTypeRequest = (
  payload: IWorkflowType,
  triggerRefresh: any
): IAction<IWorkflowType> => ({
  type: actionTypes.UPDATE_WORKFLOW_TYPE_REQUEST,
  payload,
  triggerRefresh,
});

export const updateWorkflowTypeSuccess = (): IAction<IWorkflowType> => ({
  type: actionTypes.UPDATE_WORKFLOW_TYPE_SUCCESS,
});

export const updateWorkflowTypeFailure = (error: any) => ({
  type: actionTypes.UPDATE_WORKFLOW_TYPE_FAILURE,
  payload: error,
});

export const deleteWorkflowTypeRequest = (
  id: string,
  triggerRefresh: any
): IAction<string> => ({
  type: actionTypes.DELETE_WORKFLOW_TYPE_REQUEST,
  payload: id,
  triggerRefresh,
});

export const deleteWorkflowTypeSuccess = (): IAction => ({
  type: actionTypes.DELETE_WORKFLOW_TYPE_SUCCESS,
});

export const deleteWorkflowTypeFailure = (error: any): IAction => ({
  type: actionTypes.DELETE_WORKFLOW_TYPE_FAILURE,
  payload: error,
});

export const getWorkflowTypeRequest = (id: string): IAction<string> => ({
  type: actionTypes.GET_WORKFLOW_TYPE_REQUEST,
  payload: id,
});

export const getWorkflowTypeSuccess = (): IAction => ({
  type: actionTypes.GET_WORKFLOW_TYPE_SUCCESS,
});

export const getWorkflowTypeFailure = (error: any): IAction => ({
  type: actionTypes.GET_WORKFLOW_TYPE_FAILURE,
  payload: error,
});

export const getWorkflowTypesBYServiceIdRequest = (
  id: string
): IAction<string> => ({
  type: actionTypes.GET_WORKFLOW_TYPES_BY_SERVICE_ID_REQUEST,
  id,
});

export const getWorkflowTypesBYServiceIdSuccess = (
  payload: IWorkflowType[]
): IAction<IWorkflowType[]> => ({
  type: actionTypes.GET_WORKFLOW_TYPES_BY_SERVICE_ID_SUCCESS,
  payload,
});

export const getWorkflowTypesBYServiceIdFailure = (error: any): IAction => ({
  type: actionTypes.GET_WORKFLOW_TYPES_BY_SERVICE_ID_FAILURE,
  payload: error,
});

export const getWorkflowTypesRequest = (): IAction => ({
  type: actionTypes.GET_WORKFLOW_TYPES_REQUEST,
});

export const getWorkflowTypesSuccess = (
  payload: IWorkflowType[]
): IAction<IWorkflowType[]> => ({
  type: actionTypes.GET_WORKFLOW_TYPES_SUCCESS,
  payload,
});

export const getWorkflowTypesFailure = (error: any): IAction => ({
  type: actionTypes.GET_WORKFLOW_TYPES_FAILURE,
  payload: error,
});

export const clearWorkflowTypeFetch = (): IAction => ({
  type: actionTypes.CLEAR_WORKFLOW_TYPE_FETCH,
});
